import { DeliveryInfoTemplate } from '@/modules/perseo-billing/containers/payment-complete/components/purchase-detail/deliveries';
import type { THomeDeliveryOrderConfirmation } from '@/modules/perseo-billing/interfaces/src/bff-web/billing';
import type { IconTypes } from '@/modules/perseo-billing/ui/react/src/components/beta';
import { Typography } from '@/modules/perseo-billing/ui/react/src/components/beta';
import { getDay, getMonth } from '@/modules/perseo-billing/utils';
import useRegions from '@/sections/region/hooks/useRegions';

type HomeDeliveryInfoProps = {
  delivery: THomeDeliveryOrderConfirmation;
  deliveryIcon: IconTypes;
};

const formatDeliveryDate = (
  delivery: THomeDeliveryOrderConfirmation
): string => {
  const { deliveryDateFrom, shippingServiceName, deliveryDateTo } = delivery;

  if (shippingServiceName === 'SCHEDULED_DEFERRED') return '';

  const day = getDay({
    dateString: deliveryDateFrom,
    responseFormat: 'numeric'
  });

  const month = getMonth({
    dateString: deliveryDateFrom,
    responseFormat: 'short'
  });

  if (shippingServiceName === 'DATE_RANGE') {
    const endDay = getDay({
      dateString: deliveryDateTo,
      responseFormat: 'numeric'
    });
    const endMonth = getMonth({
      dateString: deliveryDateTo,
      responseFormat: 'short'
    });
    return `del ${day} al ${endDay} de ${endMonth}`;
  }

  return `${day} de ${month}`;
};

const formatAddress = (
  delivery: THomeDeliveryOrderConfirmation,
  customerCommune: string
): string => {
  const { streetName, streetNumber } = delivery;
  return `${streetName} ${streetNumber} ${customerCommune}`;
};

export const HomeDeliveryInfo = (props: HomeDeliveryInfoProps) => {
  const { data: regions } = useRegions();
  const { delivery, deliveryIcon } = props;
  const deliveryDateString = formatDeliveryDate(delivery);

  const customerRegion = regions?.find(
    (region) => region?.id === Number(delivery?.region)
  );

  const customerCommune =
    customerRegion?.communes?.find(
      (commune) => commune?.code === delivery?.commune
    )?.name ?? '';

  const addressName = formatAddress(delivery, customerCommune);
  const timeRange = 'Horario: 09:00 a 21:00';

  const AdditionalInfo = () => {
    return (
      <div tabIndex={0} className="co-flex co-flex-col co-gap-4px co-px-16px">
        <Typography size="body2">{addressName}</Typography>
        <Typography size="body2">{timeRange}</Typography>
      </div>
    );
  };

  return (
    <DeliveryInfoTemplate
      deliveryIcon={deliveryIcon}
      title={'Despacho'}
      additionalInfo={<AdditionalInfo />}
    >
      <Typography
        size="h4"
        weight="semibold"
        color="pds-neutral-700"
        leading="24px"
      >
        {deliveryDateString}
      </Typography>
    </DeliveryInfoTemplate>
  );
};

HomeDeliveryInfo.displayName = 'HomeDeliveryInfo';

export default HomeDeliveryInfo;
